import {useServiceProviderStore} from '../store/serviceProviderStore';

export const useServiceProviderControl = () => {
  const {
    createProvider,
    updateProvider,
    deleteProvider,
    assignBrand,
    unassignBrand,
    getProviderStats,
    getProviderBrands,
    getMyBrands,
    getBrandStores
  } = useServiceProviderStore();

  return {
    createProvider,
    updateProvider,
    deleteProviderById: deleteProvider,
    assignBrand,
    unassignBrand,
    getProviderStats,
    getProviderBrands,
    getMyBrands,
    getBrandStores
  };
};
